
import { CartItem } from "@/types/cart";

export const calculateItemPrice = (item: CartItem): number => {
  const itemBasePrice = item.product.price * item.quantity;
  
  // Add safety check to ensure customizations exists and is an array before using reduce
  const customizationsPrice = Array.isArray(item.customizations) 
    ? item.customizations.reduce(
        (custTotal, cust) => custTotal + cust.price * item.quantity, 
        0
      )
    : 0;
    
  // Add extras price
  const extrasPrice = Array.isArray(item.extras)
    ? item.extras.reduce(
        (extTotal, extra) => extTotal + extra.price * item.quantity,
        0
      )
    : 0;
    
  return itemBasePrice + customizationsPrice + extrasPrice;
};

export const calculateTotalPrice = (cart: CartItem[]): number => {
  return cart.reduce((total, item) => total + calculateItemPrice(item), 0);
};

export const calculateTotalItems = (cart: CartItem[]): number => {
  return cart.reduce((total, item) => total + item.quantity, 0);
};
